import React, { FC } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles } from "@material-ui/styles";
import { Theme, useTheme } from "@material-ui/core";
import { Link } from "gatsby";

const useStyles = makeStyles((theme: Theme) => ({
  banner: {
    backgroundColor: "#6d57a8",
    width: "100%",
    minHeight: 70,
    marginTop: 7,
  },
  bannerContent: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
  },
  bannerTitle: {
    fontFamily: "Ubuntu",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: 14,
    margin: 16,
  },
  bannerTitleHiglight: {
    fontWeight: 700,
  },
  workshopLink: {
    color: "#fff !important",
    paddingLeft: "6px",
  },
}));

interface IProps {}
const DiscoverMoreBanner: FC<IProps> = () => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <div className={classes.banner}>
      <div className={classes.bannerContent}>
        <div className={classes.bannerTitle}>
          <span className={classes.bannerTitleHiglight}>
            Nulia Works v3 is here!&nbsp;
          </span>
          <span>
            With new technology reshaping our organizations, we continue to
            expand the capabilities of Nulia Works to provide a better way to
            identify the jobs to be done and empower new ways of working. With
            the launch of the latest version of Nulia Works, we are providing an
            unmatched solution that equips organizations with the ACM solution
            they need to realize up to an 11x return on their Copilot &
            Microsoft 365 investment.
          </span>
          <Link className={classes.workshopLink} to="/solution">
            Discover more.
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DiscoverMoreBanner;
